<template>
  <v-footer
    app
    color="semAz"
    class="white--text center--text"
    absolute
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-actions class="semAz white--text justify-center">
        <strong>
          <a href="https://web.infometrika.com/" target="_blank" class="white--text">
            &copy; InfometriKa {{ new Date().getFullYear() }}
          </a>
        </strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',

  data: () => ({
    //
  }),

  methods: {}
};
</script>
